module.exports = "/assets/ae432afc11ff6930cc2cf242bec839a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/EK.png
// module id = 2465
// module chunks = 0